import {
	ExarePriceDetail_ExarePriceDetailsPriceElement_Fragment,
	ExarePriceDetail_ExarePriceDetailsTaxElement_Fragment,
	ExarePriceDetailsPriceElementType
} from '@websky/graphql';

export const isFareElement = (
	price:
		| ExarePriceDetail_ExarePriceDetailsPriceElement_Fragment
		| ExarePriceDetail_ExarePriceDetailsTaxElement_Fragment
) => price.type === ExarePriceDetailsPriceElementType.fare;

export const isTaxesAgency = (
	price:
		| ExarePriceDetail_ExarePriceDetailsPriceElement_Fragment
		| ExarePriceDetail_ExarePriceDetailsTaxElement_Fragment
): price is ExarePriceDetail_ExarePriceDetailsTaxElement_Fragment =>
	price.type === ExarePriceDetailsPriceElementType.taxesAgency && 'taxCode' in price && !!price.taxCode;

export const isTaxesRetention = (
	price:
		| ExarePriceDetail_ExarePriceDetailsPriceElement_Fragment
		| ExarePriceDetail_ExarePriceDetailsTaxElement_Fragment
): price is ExarePriceDetail_ExarePriceDetailsTaxElement_Fragment =>
	price.type === ExarePriceDetailsPriceElementType.taxesRetention && 'taxCode' in price && !!price.taxCode;
